import { render, staticRenderFns } from "./AppointmentCapacities.vue?vue&type=template&id=425decf3&scoped=true"
import script from "./AppointmentCapacities.vue?vue&type=script&lang=js"
export * from "./AppointmentCapacities.vue?vue&type=script&lang=js"
import style0 from "./AppointmentCapacities.vue?vue&type=style&index=0&id=425decf3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "425decf3",
  null
  
)

export default component.exports